export function getTranslate(transform: string) {
  const groups = transform.match(/(?:translate\()(-?\d*\.?\d*)(?:px, )(-?\d*\.?\d*)(?:px)(?:\))/);

  if (!groups) {
    return {
      translateX: 0,
      translateY: 0,
    };
  }

  return {
    translateX: Number(groups[1]),
    translateY: Number(groups[2]),
  };
}

export function getElStyleTranslate(el: HTMLElement) {
  return getTranslate(el.style.transform);
}

export function formatStyleTranslate(translateX: number, translateY: number) {
  return `translate(${translateX}px, ${translateY}px)`;
}
